<template>
  <v-dialog
    v-model="show"
    max-width="700"
    persistent
  >
    <v-card>
      <v-card-title class="headline">{{$t("message.dialog.title.inputConfirm", "ja")}}</v-card-title>
      <v-card-text>{{$t("message.dialog.desc.inputConfirm", "ja")}}</v-card-text>
      <v-container v-if="optionForm">

        <!-- ID -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.mailAddress")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.mailAddress }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 氏名 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.name")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.name }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 所属 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.group")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ groupLargeName }}<span class="mx-2">＞</span>{{ groupSmallName }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 会社 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{ companyLabel.ja }}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box v-if="companyName.base">{{ companyName.base }}</mp-input-box>
            <mp-input-box v-if="companyName.kana">{{ companyName.kana }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 支社・支局 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{ branchLabel.ja }}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box v-if="branchName.base">{{ branchName.base }}</mp-input-box>
            <mp-input-box v-if="branchName.kana">{{ branchName.kana }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 郵便番号 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.postNo")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.postNo }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 都道府県 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.prefCd")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ $store.getters.prefNameByCode(optionForm.prefCd).ja }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 市区町村 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.addr1")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.addr1 }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 番地 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.addr2")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.addr2 }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- ビル名 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.addr3")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.addr3 }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 部署 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.busho")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.busho }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 電話番号 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.telNo")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>{{ optionForm.telNo }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 備考 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.remarks")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line pr-0">
            <mp-multiple-lines-input-box>{{ optionForm.remarks }}</mp-multiple-lines-input-box>
          </v-col>
        </v-row>

        <!-- 利用希望サービス -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.services")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box>
              <ul class="serviceList">
                <li v-for="s in serviceNameList" :key="s">
                  {{ s }}
                </li>
              </ul>
            </mp-input-box>
          </v-col>
        </v-row>

        <!-- 管理者設定 -->
        <v-row justify="center">
          <v-col cols="4" md="4">
            <mp-label>{{$t("message.admin.account.label.adminFlg")}}</mp-label>
          </v-col>
          <v-col cols="8" md="6" class="confirm-line">
            <mp-input-box v-if="optionForm.adminFlg">{{ $t('message.admin.account.ph.adminFlg') }}</mp-input-box>
          </v-col>
        </v-row>

      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <mp-button min class="btn-half-wide" @click="handleClickCancel">{{$t("message.dialog.button.cancel", "ja")}}</mp-button>
        <v-spacer></v-spacer>
        <mp-button min class="btn-half-wide" @click="handleClickOk">{{$t("message.dialog.button.ok", "ja")}}</mp-button>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constantValue from '@/constantValue'
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpMultipleLinesInputBox from '@/components/item/MpMultipleLinesInputBox.vue'

export default {
  components: {
    MpLabel,
    MpInputBox,
    MpButton,
    MpMultipleLinesInputBox
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    optionForm: {
      type: Object,
      default: null
    },
    group: {
      type: Array,
      default: null
    },
    company: {
      type: Array,
      default: null
    },
    branch: {
      type: Array,
      default: null
    },
    service: {
      type: Array,
      default: null
    },
    companyLabel: {
      type: Object,
      default: () => { return { ja: '' } }
    },
    branchLabel: {
      type: Object,
      default: () => { return { ja: '' } }
    }
  },
  computed: {
    groupLargeName () {
      for (const g of this.group) {
        if (g.groupLargeId === this.optionForm.groupLargeId) {
          return g.groupLargeName.ja
        }
      }
      return ''
    },
    groupSmallName () {
      for (const g of this.group) {
        if (g.groupLargeId === this.optionForm.groupLargeId) {
          for (const sg of g.groupSmallList) {
            if (sg.groupSmallId === this.optionForm.groupSmallId) {
              return sg.groupSmallName.ja
            }
          }
        }
      }
      return ''
    },
    companyName () {
      if (this.optionForm.companyId === constantValue.otherCompanyId) {
        return { base: this.optionForm.companyName, kana: this.optionForm.companyNameKana }
      }
      for (const c of this.company) {
        if (c.companyId === this.optionForm.companyId) {
          return { base: c.companyName }
        }
      }
      return {}
    },
    branchName () {
      if (this.optionForm.branchId === constantValue.otherBranchId) {
        return { base: this.optionForm.branchName, kana: this.optionForm.branchNameKana }
      }
      for (const b of this.branch) {
        if (b.branchId === this.optionForm.branchId) {
          return { base: b.branchName }
        }
      }
      return {}
    },
    serviceNameList () {
      const res = []
      for (const s of this.service) {
        if (this.optionForm.services.includes(s.serviceId)) {
          res.push(s.serviceName.ja)
        }
      }
      return res
    }
  },
  methods: {
    // OKクリック時
    handleClickOk (ev) {
      // 親のclickOkを呼び出し
      this.$emit('clickOk', ev)
    },
    // キャンセルクリック時
    handleClickCancel (ev) {
      // 親のclickCancelを呼び出し
      this.$emit('clickCancel', ev)
    }
  }
}
</script>

<style scoped>
.confirm-line {
  border-bottom: solid 1px rgba(0, 0, 0, 0.33);
}
.btn-half-wide {
  width: 45%;
}
</style>
